require('../polly/presigner');


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/polly.js
// module id = 1713
// module chunks = 0